import { Types } from "../Constants/Types";
import WarehouseOpsType from "../Interfaces/warehouse-ops.interface";

const ReceivingReducer = (
  state: WarehouseOpsType["receivingState"] = {
    shipments: [],
    shipment: undefined,
    lshipments: false,
    lshipment: false,
    ladvance: false,
  },
  action: WarehouseOpsType["action"]
) => {
  switch (action.type) {
    case Types.FETCH_RECEIVING_SHIPMENTS:
      return { ...state, shipments: action.payload };

    case Types.FETCH_RECEIVING_SHIPMENT:
      return { ...state, shipment: action.payload };

    case Types.UPDATE_RECEIVING_SHIPMENT:
      return {
        ...state,
        shipment:
          state.shipment &&
          state.shipment.trackingNumber === action.payload.trackingNumber
            ? { ...state.shipment, ...action.payload }
            : state.shipment,
        shipments: state.shipments.map((s) =>
          s.trackingNumber === action.payload.trackingNumber
            ? { ...s, ...action.payload }
            : s
        ),
      };

    case Types.START_RECEIVING_SHIPMENTS:
      return { ...state, lshipments: true };

    case Types.END_RECEIVING_SHIPMENTS:
      return { ...state, lshipments: false };

    case Types.START_RECEIVING_SHIPMENT:
      return { ...state, lshipment: true, shipment: undefined };

    case Types.END_RECEIVING_SHIPMENT:
      return { ...state, lshipment: false };

    case Types.START_ADVANCE_SHIPMENT:
      return { ...state, ladvance: true };

    case Types.END_ADVANCE_SHIPMENT:
      return { ...state, ladvance: false };

    default:
      return state;
  }
};

export default ReceivingReducer;
